import { FC, HTMLAttributes, useMemo } from 'react';

import Clock from '@/assets/icons/Clock';
import Koppel from '@/assets/icons/KoppelConflict';
import Perronlengte from '@/assets/icons/Perronlengte';
import Plaatsconflict from '@/assets/icons/Plaatsconflict';
import TrainManco from '@/assets/icons/TrainManco';
import VerkeerdMat from '@/assets/icons/VerkeerdMat';
import Versterken from '@/assets/icons/Versterken';
import { ConflictType } from '@/types/Conflicten';

import styles from './ConflictIcon.module.css';

type ConflictIconProps = HTMLAttributes<SVGSVGElement> & {
  className?: string;
  type: ConflictType;
  tooltip?: boolean;
};
const ConflictIcon: FC<ConflictIconProps> = ({
  type,
  className = styles.conflictIcon,
  tooltip = false,
  ...svgProps
}) => {
  const Component = useMemo(() => {
    const icons = {
      MANCO: TrainManco, // trein met kruisje
      PLAATS: Plaatsconflict, // locatie-pin
      VERKEERD_MATERIEEL: VerkeerdMat, // twee vierkantjes met pijltje
      VERSTERKT_MATERIEEL: Versterken, // plusje met cirkel
      PERRONLENGTE: Perronlengte,
      KOPPEL: Koppel,
    };
    return icons?.[type] ?? Clock;
  }, [type]);
  return (
    <Component
      className={tooltip && type === 'PERRONLENGTE' ? styles.conflictIconTooltipPerronlengte : className}
      {...svgProps}
    />
  );
};
export default ConflictIcon;
